import {LitElement, svg, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {getValueOfFeature} from '../../../util/values';
import {selectConstructionDecided, selectSpcConfiguration} from '../../../selectors';

@customElement('svg-lightdistribution')
export class SvgLightdistribution extends connect(store)(LitElement) {

	static styles = css`
	  :host {
		display: flex;
	  }

	  svg {
		height: 100%;
		width: auto;
		margin: auto;
	  }

	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.spcConfiguration = selectSpcConfiguration(state);
		this.status = state.status;
	}

	render() {
		const s = this.state;
		const svgPath = this.status.host + this.status.baseUrl + '/visuals/line-lightdistribution.svg';
		return svg`
			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1600" height="1600" viewBox="0 0 1600 1600">
    			<g id="line-lightdistribution" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(800,800) translate(-800,-800)">
					${when(selectConstructionDecided(s), () => svg`
						<use href="${svgPath}#${getValueOfFeature('shared::PoleSpecialLine::HS_Construction', this.spcConfiguration)}"></use>
					`, () => svg`
						<use href="${svgPath}#Default-${getValueOfFeature('shared::ProductType::HS_HousingType', this.spcConfiguration)}"></use>
					`)}
				</g>
			</svg>
		`;
	}
}
